import { handleUrl, myHeadersWithTokenContentType } from '../../global';
import { DetailProps } from '../notices/types';
import { CreateCompanyCommentData, ListCompanyCommentsResponse } from './types';

// Contrato definido em Plans/company-comments-handoff.md e implementado no
// backend em REAL-3192. Comentário é nota interna do banco: o prestador recebe
// 403 nas três rotas, pela policy do servidor.
//
// A leitura degrada em silêncio na UI (estado vazio, sem snackbar) e a escrita
// reporta erro — então um 500 de leitura fica invisível aqui e só aparece no log
// do servidor.

export const listNoticeCompanyComments = (
  publicNoticeId: number,
  licensedCompanyId: number,
  page: number,
  size: number
): Promise<ListCompanyCommentsResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };

  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });

  const baseUrl = handleUrl();
  return fetch(
    // eslint-disable-next-line max-len
    `${baseUrl}/api/V1/public-notices/${publicNoticeId}/licensed-companies/${licensedCompanyId}/comments?${params.toString()}`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const createNoticeCompanyComment = (
  publicNoticeId: number,
  licensedCompanyId: number,
  data: CreateCompanyCommentData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };

  const baseUrl = handleUrl();
  return fetch(
    // eslint-disable-next-line max-len
    `${baseUrl}/api/V1/public-notices/${publicNoticeId}/licensed-companies/${licensedCompanyId}/comments`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

// Histórico que atravessa editais, ancorado na credenciada — é o que dá o
// "durante a vida do profissional".
export const listCompanyCommentsHistory = (
  licensedCompanyId: number,
  page: number,
  size: number
): Promise<ListCompanyCommentsResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };

  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });

  const baseUrl = handleUrl();
  return fetch(
    // eslint-disable-next-line max-len
    `${baseUrl}/api/V1/licensed-companies/${licensedCompanyId}/comments?${params.toString()}`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};
